"use client";

import categoryData from "@/public/ecomsaas-assets/cache/category.json";
import featured_categoriesData from "@/public/ecomsaas-assets/cache/featured_categories.json";
import best_sellersData from "@/public/ecomsaas-assets/cache/best_sellers.json";
import top_ratedData from "@/public/ecomsaas-assets/cache/top_rated.json";
import Footer from "@/components/layouts/Footer";
import Navbar from "@/components/layouts/Navbar";
import Homepage from "@/components/home/Homepage";

export const runtime = "edge";

// Define the Product interface
export interface Product {
  id: number;
  name: string;
  eng_name: string;
  descp: string;
  sp: number;
  mrp: number;
  imageurl: string;
  seo_url: string;
  category_name: string;
  created_at: string;
  category?: string; // Optional, in case `Homepage` expects it
}

// === ADDED: Canonical link for SEO (fixes redirect-inlink issue) ===
import Head from "next/head";

export default function HomePage() {
  return (
    <>
      {/* SEO: Explicit canonical URL to prevent redirect reliance */}
      <Head>
        <link rel="canonical" href="https://www.lunaleaf.in/" />
      </Head>

      <div className="flex flex-col">
        <Navbar categoryListData={categoryData} />
        <Homepage
          categoryListData={categoryData}
          featuredcategoriesListData={featured_categoriesData}
          bestsellersListData={best_sellersData}
          topratedListData={top_ratedData}
        />
        {/* <Footer categoryListData={categoryData} /> */}
        <Footer />
      </div>
    </>
  );
}